/* eslint-disable @typescript-eslint/member-ordering */
import classNames from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslate } from '../../mixins/translate/translate';
import { PanelButtonLink } from '../elements';

type ListPagerProps = {
    total: number;
    page: number;
    itemsPerPage: number;
    handleNavigation: (page: number) => void;
    disabled: boolean;
    inPanel?: boolean;
    mirrorQueryParams?: boolean;
    navigationTitles?: boolean;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ListPager = (props: ListPagerProps) => {
    const navigateToUrl = useNavigate();
    const translate = useTranslate();
    const numberOfPages = Math.ceil(props.total / props.itemsPerPage);
    const prevClassName = classNames({ prev: true, disabled: props.page === 1 || props.disabled });
    const nextClassName = classNames({ next: true, disabled: props.page === numberOfPages || props.disabled });

    const navigate = (page: number, e?: any) => {
        if (e) {
            e.preventDefault();
        }

        if (page > 0 && page <= numberOfPages) {
            updateQueryParams(page);
            props.handleNavigation(page);
        }
    };

    const updateQueryParams = (page: number) => {
        if (!props.mirrorQueryParams) {
            return;
        }

        const queryObject = new URLSearchParams(location.search);
        queryObject.set('page', page.toString());
        const search = `?${queryObject.toString()}`;
        const { pathname } = location;
        navigateToUrl({ pathname, search });
    };

    if (props.total === 0 || numberOfPages === 1) {
        return null;
    }

    if (props.inPanel) {
        return (
            <>
                <PanelButtonLink
                    text={translate('common.previous')}
                    onClick={() => navigate(props.page - 1)}
                    icon="fa fa-angle-left"
                    small={true}
                    disabled={props.page === 1}
                />
                <PanelButtonLink
                    onClick={() => navigate(props.page + 1)}
                    icon="fa fa-angle-right"
                    small={true}
                    disabled={props.page === numberOfPages}
                    text={translate('common.next')}
                    navigationTitles={props.navigationTitles ? props.navigationTitles : false}
                />
            </>
        );
    }

    return (
        <div className="panel-footer clearfix">
            <nav>
                <ul className="pagination pull-right">
                    <li className={prevClassName}>
                        <a href="#" onClick={(e) => navigate(props.page - 1, e)}>
                            <i className="fa fa-angle-left"></i> {translate('common.previous')}
                        </a>
                    </li>
                    <li className={nextClassName}>
                        <a href="#" onClick={(e) => navigate(props.page + 1, e)}>
                            {translate('common.next')} <i className="fa fa-angle-right"></i>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    );
};
